import { LanguageEnum, VoiceGenderTypeEnum } from '../../index.js'

/**
 * Appointments Request DTO
 */
export interface AppointmentsReq {
	/**
	 * ID
	 */
	id: string
}

/**
 * Appointments Modify Request DTO
 * @extends {AppointmentsReq}
 */
export interface AppointmentsModifyReq extends AppointmentsReq {
	/**
	 * Capacity
	 */
	capacity: number
	/**
	 * 開始時間 Unix time
	 */
	start_unix_time: number
	/**
	 * 結束時間 Unix time
	 */
	end_unix_time: number
	/**
	 * 性別陣列
	 */
	genders: Array<VoiceGenderTypeEnum>
	/**
	 * 語言陣列
	 */
	languages: Array<LanguageEnum>
}
